import {
    FETCH_RANK_REQUEST,
    FETCH_RANK_SUCCESS,
    FETCH_RANK_FAILURE,
    CLEAR_RANK_DATA,
    FETCH_ON_AIR_REQUEST,
    FETCH_ON_AIR_SUCCESS,
    FETCH_ON_AIR_FAILURE,
    CLEAR_ON_AIR_DATA
} from '../actions/collectionActions';

const initialStateRank = {
    data: [],
    loading: false,
    error: null,
};

const initialStateOnAir = {
    inArenaHorse: [],
    loading: false,
    error: null,
    viewHorseBox: false,
    inArenaHorseId: ''
};

export const showTemporaryRankReducer = (state = initialStateRank, action) => {
    switch (action.type) {
        case FETCH_RANK_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_RANK_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            };
        case FETCH_RANK_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case CLEAR_RANK_DATA:
            return {
                ...state,
                data: [],
                error: null,
                loading: false
            };
        default:
            return state;
    }
};

export const horseOnAirReducer = (state = initialStateOnAir, action) => {
    switch (action.type) {
        case FETCH_ON_AIR_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_ON_AIR_SUCCESS:
            let newState = { ...state, loading: false };
            if (action.payload?.length > 0) {
                const payloadItem = action.payload[0];
                if (payloadItem?.Action == 5 || payloadItem?.Action == 3) {
                    if (state.inArenaHorse.HorseId === payloadItem?.HorseId) {
                        newState.viewHorseBox = false;
                        newState.inArenaHorse = {};
                    }
                } else if (payloadItem?.Action == 1) {
                    newState.viewHorseBox = true;
                    newState.inArenaHorse = payloadItem;
                    newState.inArenaHorseId = payloadItem?.HorseId;
                }
            } else {
                newState.inArenaHorse = {};
            }
            return newState;
        case FETCH_ON_AIR_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case CLEAR_ON_AIR_DATA:
            return {
                ...state,
                inArenaHorse: [],
                error: null,
                loading: false,
                viewHorseBox: false,
                inArenaHorseId: ''
            };
        default:
            return state;
    }
};
